import { FormTypes } from '~/pages/IncomeCalculator/enums';
import type { CalculationResult } from '~/pages/IncomeCalculator/types';

import SelfEmploymentTrendingAnalysis from '../SelfEmploymentTrendingAnalysis';

type TrendingAnalysisProps = {
  selectedResult: CalculationResult;
};

const TrendingAnalysis = ({ selectedResult }: TrendingAnalysisProps) => (
  <SelfEmploymentTrendingAnalysis
    isPositiveTrend={selectedResult
      .getInput(FormTypes.Form1065Output, 0, 'isPositiveTrend')
      ?.fieldValue?.toLowerCase()}
    grossMinusCogs={selectedResult.getInputAsFloat(
      FormTypes.Form1065Output,
      0,
      'percentChangeInGrossMinusCogs',
    )}
    expenses={selectedResult.getInputAsFloat(
      FormTypes.Form1065Output,
      0,
      'percentChangeInExpenses',
    )}
    tangibleIncome={selectedResult.getInputAsFloat(
      FormTypes.Form1065Output,
      0,
      'percentChangeInTangibleIncome',
    )}
  />
);

export default TrendingAnalysis;
